import React, {ReactElement, SVGProps} from 'react';
import cn from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
interface CopyIconProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

export const CopyIcon: React.FC<CopyIconProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={cn(props.className, 'icon copy')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512">
        <path d="M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z" />
      </svg>
    </Tooltip>
  );
};
